import { NorthEast } from "@mui/icons-material";
import { Grid2 } from "@mui/material";

import { StyledCardBox, StyledTitle, iconSx } from "./ResourcesCard.styles";

const ResourcesCard = ({ title, setModalState, bigB, link, openModal }) => {
  const isClickable = openModal || link;

  const handleClick = () => {
    if (openModal) {
      setModalState(true);
    } else if (link) {
      window.open(link, "_blank");
    }
  };

  return (
    <Grid2 item size={{ xs: 12, sm: 6, lg: 4 }}>
      <StyledCardBox isClickable={isClickable} onClick={handleClick}>
        <StyledTitle>{title}</StyledTitle>
        {link && <NorthEast sx={iconSx} />}
      </StyledCardBox>
    </Grid2>
  );
};

export default ResourcesCard;
